import React from "react";
import { Button, Typography, Space, Divider } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

export default function Privacy() {
  const navigate = useNavigate();
  const { Title, Text, Paragraph } = Typography;

  return (
    <>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            style={{ padding: 0 }}
          />
          <Title level={3} style={{ margin: 0 }}>
            Declaração de Privacidade
          </Title>
        </div>

        <div>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Paragraph>
              <Text strong>Última atualização:</Text>{" "}
              {new Date().toLocaleDateString("pt-BR")}
            </Paragraph>

            <Paragraph style={{ textAlign: 'justify' }}>
              Nós valorizamos sua privacidade e estamos comprometidos em
              proteger seus dados pessoais. Esta Declaração de Privacidade
              descreve como coletamos, usamos e protegemos suas informações.
            </Paragraph>

            <section>
              <Title level={4}>1. Informações que Coletamos</Title>
              <Paragraph>
                Coletamos informações que você nos fornece diretamente, como:
              </Paragraph>
              <ul>
                <li>Dados de cadastro (nome, e-mail, etc.)</li>
                <li>Informações de uso da plataforma</li>
                <li>Dados de navegação e cookies</li>
              </ul>
            </section>

            <section>
              <Title level={4}>2. Como Usamos Suas Informações</Title>
              <Paragraph>Utilizamos seus dados para:</Paragraph>
              <ul>
                <li>Fornecer e melhorar nossos serviços</li>
                <li>Personalizar sua experiência</li>
                <li>Comunicar atualizações importantes</li>
                <li>Garantir a segurança da plataforma</li>
              </ul>
            </section>

            <section>
              <Title level={4}>3. Compartilhamento de Dados</Title>
              <Paragraph>
                Não vendemos, comercializamos ou transferimos suas informações
                pessoais para terceiros, exceto quando necessário para fornecer
                nossos serviços ou quando exigido por lei.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>4. Segurança dos Dados</Title>
              <Paragraph>
                Implementamos medidas de segurança apropriadas para proteger
                suas informações contra acesso não autorizado, alteração,
                divulgação ou destruição não autorizada.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>5. Seus Direitos</Title>
              <Paragraph>Você tem o direito de:</Paragraph>
              <ul>
                <li>Acessar seus dados pessoais</li>
                <li>Corrigir dados incorretos</li>
                <li>Solicitar a exclusão de seus dados</li>
                <li>Retirar seu consentimento</li>
              </ul>
            </section>

            <section>
              <Title level={4}>6. Retenção de Dados</Title>
              <Paragraph>
                Mantemos seus dados apenas pelo tempo necessário para cumprir os
                propósitos descritos nesta política, a menos que um período de
                retenção mais longo seja necessário por obrigações legais ou
                regulatórias.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>7. Cookies</Title>
              <Paragraph>
                Usamos cookies para melhorar sua experiência na plataforma. Você
                pode configurar seu navegador para recusar cookies, mas isso
                pode afetar a funcionalidade de alguns recursos.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>8. Alterações nesta Política</Title>
              <Paragraph>
                Podemos atualizar esta Declaração de Privacidade periodicamente.
                Notificaremos você sobre quaisquer alterações significativas
                publicando a nova política nesta página.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>9. Contato</Title>
              <Paragraph>
                Se você tiver dúvidas sobre esta Declaração de Privacidade ou
                sobre como tratamos seus dados, entre em contato conosco através
                dos canais de suporte disponíveis na plataforma.
              </Paragraph>
            </section>

            <Divider />

            <Text type="secondary" style={{ fontSize: "12px" }}>
              Ao usar nossa plataforma, você concorda com a coleta e uso de suas
              informações conforme descrito nesta Declaração de Privacidade.
            </Text>
          </Space>
        </div>
      </Space>
    </>
  );
}
